<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fTYUGI/tc-custom/9781504051743.jpg?1734325844577" alt="This image is the cover for the book Knocked for a Loop, The John J. Malone Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Knocked for a Loop, The John J. Malone Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Being framed for murder is the least of a Chicago attorney’s problems in this dizzying thriller by “the grand dame of mystery mixed with screwball comedy” (Ed Gorman).</b><br/>  <br/> Attorney John J. Malone, steadfast barfly and proud defender of the guilty, has a lot enemies, but few more formidable than Chicago financier and anti-vice crusader Leonard Estapole. So it doesn’t look good when Estapole’s corpse turns up in Malone’s office, liberated from this life by a bronze Buddha to the skull. But when the stiff’s stepdaughter is kidnapped, and Malone is implicated, it’s a frame job gone too far. Especially when Malone is suddenly saddled with the obnoxious abductee—a dimpled little extortionist who refuses to go home.<br/>  <br/> If only Malone could count on his friends, Jake and Helene Justus. Unfortunately, Helene’s disappeared from a Wyoming dude ranch and her friendship with Estapole’s trophy-wife widow is too coincidental for comfort. Now, with every blindsiding twist of the case, Malone is starting to feel more and more like a hostage himself.<br/>  <br/> The first mystery writer to ever make the cover of <i>Time</i> magazine, Craig Rice is a “composite of Agatha Christie’s ingenuity, Dashiell Hammett’s speed, and Dorothy Sayers’s wit” (Louis Untermeyer). And in <i>Knocked for a Loop</i>, she’s in “top form” (Jon L. Breen, Edgar Award–winning author).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Rice
      </h2>
      
      <p class="authorDescription body article">Craig Rice (1908&ndash;1957), born Georgiana Ann Randolph Craig, was an American author of mystery novels and short stories described as &ldquo;the Dorothy Parker of detective fiction.&rdquo; In 1946, she became the first mystery writer to appear on the cover of <I>Time </I>magazine. Best known for her character John J. Malone, a rumpled Chicago lawyer, Rice&rsquo;s writing style was both gritty and humorous. She also collaborated with mystery writer Stuart Palmer on screenplays and short stories, as well as with Ed McBain on the novel <I>The April Robin Murders</I>.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16366f09